const defaults = {
  veil: {
    __typename: 'Veil',
    active: false
  }
}

const resolvers = {
  Mutation: {
    toggleVeil: (_, { active }, { cache }) => {
      const data = {
        veil: {
          __typename: 'Veil',
          active
        }
      }
      cache.writeData({ data })
      return null
    }
  }
}

export default {
  defaults,
  resolvers
}
